export default "__VITE_ASSET__0225596f__"